<template>
  <div class="event">
    <div
      class="new-circle"
      v-if="event.waiting_web_delivery && showNewCircle"
    ></div>
    <div
      class="points"
      v-if="points"
      :class="{ 'points-up': isPointsUp, 'points-down': isPointsDown }"
    >
      <div class="points-tag">
        <div v-if="isPointsUp" class="points-up-sign">+</div>
        <div v-if="isPointsDown" class="points-down-sign">-</div>
        <div class="points-icon">
          <img src="/images/icons/snap.svg" class="snaps-icon" />
        </div>
        <div class="points-number points-up">{{ points }}</div>
      </div>
    </div>
    <div class="review-icon" v-if="isReview">
      <img src="/images/icons/reviews.svg" class="icon-reviews" />
    </div>
    <div class="approval-icon" v-if="isApproval">
      <i class="material-icons approval-icon-i">check_circle</i>
    </div>
    <div class="pubby-prize-icon" v-if="isPubbyPrize">
      <img src="/images/icons/further-prize.svg" class="icon-pubby-prize" />
    </div>
    <div class="content" v-html="event.content + '.'"></div>
    <div class="time" v-html="time"></div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Event",
  props: ["event", "showNewCircle"],
  computed: {
    time() {
      let time = moment(new Date(this.event.created_at)).fromNow();

      time = time.replace(/ days/, "d");
      time = time.replace(/ weeks/, "w");
      time = time.replace(/ months/, "mo");

      time = time.replace(/ day/, "d");
      time = time.replace(/ week/, "w");
      time = time.replace(/ month/, "mo");

      time = time.replace(/ad/, "1d");
      time = time.replace(/aw/, "1w");
      time = time.replace(/amo/, "1mo");

      let pattern = / /gi;
      time = time.replace(pattern, "&nbsp;");

      return time;
    },
    points() {
      let points = this.event.points;

      if (points < 0) {
        points *= -1;
      }

      return points;
    },
    isPointsUp() {
      return this.event.points > 0;
    },
    isPointsDown() {
      return this.event.points < 0;
    },
    isReview() {
      return this.event.content.indexOf("has been reviewed") !== -1;
    },
    isPubbyPrize() {
      return this.event.content.indexOf("Pubby Prize") !== -1;
    },
    isApproval() {
      return (
        this.event.content.indexOf("was approved") !== -1 &&
        this.event.content.indexOf("book") !== -1
      );
    },
  },
  mounted() {},
  created() {
    // console.log("Event created", this.event);
    // if (this.event.created_at) {
    //   this.event.created_at = this.event.created_at.replace("-", "/");
    // }
  },
};
</script>

<style lang="scss">
.event {
  margin-top: 10px;
  padding-bottom: 10px;
  display: flex;
  border-bottom: 1px solid #eaeaea;
  font-family: $font-family;
  font-weight: 500;
  font-size: 12pt;
  color: #333;
}
.event:last-child {
  border-bottom: 0 !important;
}

.new-circle {
  flex-basis: 10px;
  flex-grow: 0;
  width: 10px;
  min-width: 10px;
  height: 10px;
  margin-top: 11px;
  margin-right: 8px;
  border-radius: 12px;
  background: #ef5350;
}

.time {
  flex-grow: 0;
  font-size: 12pt;
  margin-left: auto;
  padding: 4px 1em 0 0px;
  color: #888;
}

.content {
  flex-grow: 1;
  padding: 4px 12px 0 0px;
}

.context {
  font-weight: 600;
  color: $color-blue;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 200px;
}

.context-intercom_name {
  color: darken($color-blue, 25%);
}

.points {
  height: 28px;
}
.points-tag {
  display: flex;
  background: #fff;
  margin-top: 3px;
  margin-right: 8px;
  border-radius: 40px;
  padding-right: 0px;

  .points-icon {
    font-size: 16px;
    margin: 0;
    padding: 0;
    padding-left: 1px;
    line-height: 26px;
    color: $color-snaps;
  }

  .points-number {
    padding: 0px 0 0 3px;
    font-size: 12pt;
    font-weight: 600;
    line-height: 25px;
    color: darken($color-snaps, 3%);
  }
}
.is-friend .points-tag {
  display: none;
}

.review-icon,
.pubby-prize-icon,
.approval-icon {
  margin-top: 7px;
  margin-right: 8px;
  line-height: 1px;

  .icon-reviews {
    width: 20px;
    margin-top: 0px;
  }
  .icon-pubby-prize {
    width: 20px;
    margin-top: 0px;
  }
}

.approval-icon {
  margin-top: 5px !important;
}
.approval-icon-i {
  font-size: 16pt;
  color: #43a047;
}

.snaps-icon {
  float: left;
  width: 20px;
  margin: 8px 0 0 3px;
}

.points-up {
  .points-tag {
    // background: #dcedc8 !important;
  }
}
.points-down {
  .points-tag {
    //background: lighten(#ffcdd2, 3%) !important;
  }
}

.points-up-sign {
  line-height: 24px;
  font-size: 19pt;
  font-weight: 700;
  color: #66bb6a;
}
.points-down-sign {
  line-height: 22px;
  font-size: 19pt;
  font-weight: 700;
  color: #aaa;
}

@media (max-width: 768px) {
  .time {
    padding: 4px 0em 0 0px !important;
  }
}
</style>


